import axios from "axios";

const token = localStorage.getItem("token");
axios.defaults.baseURL = process.env.VUE_APP_API_URL;
axios.defaults.headers.common["Accept"] = "application/json; version=1.0";

if (token) {
  axios.defaults.headers.common["Authorization"] = token;
}
